import { REPORTS_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import reportsTypes from '../../constants/reportsTypes'
import { axios } from '../../services'

// 1 publish
// 2 publish_all
// 3 unpublish
// 4 unpublish_all
// 5 update_xml

// 1 publish
const publish_report_request = () => {
  return {
    type: reportsTypes.publish.request
  }
}

const publish_report_success = (response) => {
  return {
    type: reportsTypes.publish.success,
    payload: response.data.report
  }
}

const publish_report_minimal_success = (response) => {
  return {
    type: reportsTypes.publish.success_minimal,
    payload: response.data
  }
}

const publish_report_failure = (messages) => {
  return {
    type: reportsTypes.publish.failure,
    payload: messages
  }
}

const publish_report = (report_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_report_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.publish, {id: report_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( publish_report_minimal_success(response) )
      } else {
        dispatch( publish_report_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing report."]
      }
      dispatch( publish_report_failure( errors ) )
    })
  }
}

// 2 publish_all
const publish_all_request = () => {
  return {
    type: reportsTypes.publish_all.request
  }
}

const publish_all_success = (response) => {
  return {
    type: reportsTypes.publish_all.success,
    payload: response.data
  }
}

const publish_all_failure = (messages) => {
  return {
    type: reportsTypes.publish_all.failure,
    payload: messages
  }
}

const publish_all = (report_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_all_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.publish_all, {id: report_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      dispatch( publish_all_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing all project reports."]
      }
      dispatch( publish_all_failure( errors ) )
    })
  }
}

// 3 UNpublish
const unpublish_report_request = () => {
  return {
    type: reportsTypes.unpublish.request
  }
}

const unpublish_report_success = (response) => {
  return {
    type: reportsTypes.unpublish.success,
    payload: response.data.report
  }
}

const unpublish_report_minimal_success = (response) => {
  return {
    type: reportsTypes.unpublish.success_minimal,
    payload: response.data
  }
}

const unpublish_report_failure = (messages) => {
  return {
    type: reportsTypes.unpublish.failure,
    payload: messages
  }
}

const unpublish_report = (report_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_report_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.unpublish, {id: report_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( unpublish_report_minimal_success(response) )
      } else {
        dispatch( unpublish_report_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unpublishing report."]
      }
      dispatch( unpublish_report_failure( errors ) )
    })
  }
}

// 4 unpublish_all
const unpublish_all_request = () => {
  return {
    type: reportsTypes.unpublish_all.request
  }
}

const unpublish_all_success = (response) => {
  return {
    type: reportsTypes.unpublish_all.success,
    payload: response.data
  }
}

const unpublish_all_failure = (messages) => {
  return {
    type: reportsTypes.unpublish_all.failure,
    payload: messages
  }
}

const unpublish_all = (report_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_all_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.unpublish_all, {id: report_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      console.log(response)
      dispatch( unpublish_all_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = ["Error unpublishing all project reports."]
        errors = [error]
      }
      dispatch( unpublish_all_failure( errors ) )
    })
  }
}

// 5 update_xml
const update_xml_request = () => {
  return {
    type: reportsTypes.update_xml.request
  }
}

const update_xml_success = (response) => {
  return {
    type: reportsTypes.update_xml.success,
    payload: response.data.report
  }
}

const update_xml_minimal_success = (response) => {
  return {
    type: reportsTypes.update_xml.success_minimal,
    payload: response.data
  }
}

const update_xml_failure = (messages) => {
  return {
    type: reportsTypes.update_xml.failure,
    payload: messages
  }
}

const update_xml = (report_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.update_xml, {id: report_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( update_xml_minimal_success(response) )
      } else {
        dispatch( update_xml_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}

const upload_new = (report_id, formData) => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.upload_new, {id: report_id}),
      formData
    ).then( response => {
      // success
      dispatch( update_xml_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}

const clone_report = (report_id, page=1, name) => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(REPORTS_ROUTES.clone, {id: report_id}),
      {
        page: page,
        per_page: 10,
        name: name !== undefined && name !== null ? name : ""
      }
    ).then( response => {
      // success
      dispatch( update_xml_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}


export {
  publish_report,
  publish_all,
  unpublish_report,
  unpublish_all,
  update_xml,
  upload_new,
  clone_report
}



// WEBPACK FOOTER //
// ./src/js/actions/reports/publish_actions.js